package com.eladfinish.bible.contest.data

import androidx.compose.runtime.Stable

// TODO: try to use VerseUiModel instead
@Stable
data class VerseEntity(
    val bookIndex: Int,
    val strBook: String,
    val strBookHebrew: String? = null,
    val strChapter: String,
    val strVerse: String,
    val strPasuk: String, // content of the verse
    val strReysah: String? = null,
    val strSeyfa: String? = null,
    val strExtraData: String? = null, // משורר בתהילים, דובר באיוב
) {

    override fun toString(): String = "\n[$strVerse] $strReysah, $strSeyfa"
}
